helpers = (function () {
  function getSymbolPos(reel, row, ignoreSlotContainer = false) {
    const symbolReel = resourceManager.get('slotContainer:reelContainer:reel' + reel);
    const symPos = {
      x: symbolReel.x,
      y: symbolReel.y + row * gameData.symbolHeight,
    };

    if (ignoreSlotContainer) {
      return symPos;
    }

    const containerPos = resourceManager.get('slotContainer').position;
    const containerScaleX = resourceManager.get('slotContainer').scale.x;
    const containerScaleY = resourceManager.get('slotContainer').scale.y;

    let pos = {
      x: symPos.x * containerScaleX + containerPos.x,
      y: symPos.y * containerScaleY + containerPos.y,
    };
    return pos;
  }

  return {
    getSymbolPos: getSymbolPos,
  };
})();
